import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ClientSettings } from "src/model/class/client-settings";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";

/**
 * Select plant list
 */
export const clientSettings = createFeatureSelector<ClientSettings>(
  AppSettings.KEY_CLIENT_OPTIONS
);
